import { Link, useParams } from "react-router-dom";
import Navbar from "../components/Navbar";
import { getBlockInfo } from "../services/utils";
import { useEffect, useState } from "react";

const Block = () => {
    let { blockNumber } = useParams();
    const [block, setBlock] = useState();
    useEffect(() => {
        const fetchBlock = async () => {
            try {
                if (blockNumber) {
                    const blockData = await getBlockInfo(blockNumber);
                    console.log(blockData);
                    setBlock(blockData);
                }
            } catch (error) {
                console.log(error);
            }
        };
        fetchBlock();
    }, [blockNumber]);
    return (
        <>
            <div className="h-screen">
                <Navbar />
                {block && (
                    <div className="w-[90%] flex flex-col mx-auto gap-10 mt-20">
                        <div>
                            <h1 className="font-semibold text-2xl">
                                Block #{block?.number}
                            </h1>
                        </div>
                        <div>
                            <table className="text-sm text-left w-full rtl:text-right text-gray-500 border border-1 border-gray-100 rounded-l">
                                <tbody>
                                    <tr class="odd:bg-white even:bg-gray-50 border-b">
                                        <td class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                            Block Height
                                        </td>
                                        <td class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                            {block?.number}
                                        </td>
                                    </tr>
                                    <tr class="odd:bg-white even:bg-gray-50 border-b">
                                        <td class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                            Status
                                        </td>
                                        <td class="px-6 py-4 font-medium text-blue-400 whitespace-nowrap">
                                            {block?.hash}
                                        </td>
                                    </tr>
                                    <tr class="odd:bg-white even:bg-gray-50 border-b">
                                        <td class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                            Timestamp
                                        </td>
                                        <td class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                            {new Date(
                                                block?.timestamp * 1000
                                            )?.toLocaleDateString("en-En", {
                                                weekday: "long",
                                                year: "numeric",
                                                month: "long",
                                                day: "numeric",
                                            })}
                                        </td>
                                    </tr>
                                    <tr class="odd:bg-white even:bg-gray-50 border-b">
                                        <td class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                            Purposed On
                                        </td>
                                        <td class="px-6 py-4 font-medium text-blue-400 whitespace-nowrap">
                                            {block?.miner}
                                        </td>
                                    </tr>
                                    <tr class="odd:bg-white even:bg-gray-50 border-b">
                                        <td class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                            Transactions
                                        </td>
                                        <td class="px-6 py-4 font-medium text-blue-400 whitespace-nowrap">
                                            {block?.transactions.length}
                                        </td>
                                    </tr>
                                    <tr class="odd:bg-white even:bg-gray-50 border-b">
                                        <td class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                            Withdrawals
                                        </td>
                                        <td class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                            {parseInt(
                                                block?.gasUsed?._hex,
                                                16
                                            ) / 1e9}{" "}
                                            ETH
                                        </td>
                                    </tr>
                                    <tr class="odd:bg-white even:bg-gray-50 border-b">
                                        <td class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                            Fee Recepients
                                        </td>
                                        <td class="px-6 py-4 font-medium text-blue-400 whitespace-nowrap">
                                            {block?.miner}
                                        </td>
                                    </tr>
                                    <tr class="odd:bg-white even:bg-gray-50 border-b">
                                        <td class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                            Block Reward
                                        </td>
                                        <td class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                            {parseInt(
                                                block?.baseFeePerGas._hex,
                                                16
                                            ) / 1e9}{" "}
                                            Gwei
                                        </td>
                                    </tr>
                                    <tr class="odd:bg-white even:bg-gray-50 border-b">
                                        <td class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                            Total Difficulty
                                        </td>
                                        <td class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                            {parseInt(
                                                block?._difficulty._hex,
                                                16
                                            )}
                                        </td>
                                    </tr>
                                    <tr class="odd:bg-white even:bg-gray-50 border-b">
                                        <td class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                            Size
                                        </td>
                                        <td class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                            N/A
                                        </td>
                                    </tr>
                                    <tr class="odd:bg-white even:bg-gray-50 border-b">
                                        <td class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                            Gas Used
                                        </td>
                                        <td class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                            {parseInt(
                                                block?.gasUsed?._hex,
                                                16
                                            ).toLocaleString()}{" "}
                                            (
                                            {(
                                                (parseInt(
                                                    block?.gasUsed?._hex,
                                                    16
                                                ) /
                                                    parseInt(
                                                        block?.gasLimit._hex,
                                                        16
                                                    )) *
                                                100
                                            ).toFixed(2)}
                                            %)
                                        </td>
                                    </tr>
                                    <tr class="odd:bg-white even:bg-gray-50 border-b">
                                        <td class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                            Gas Limit
                                        </td>
                                        <td class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                            {parseInt(
                                                block?.gasLimit._hex,
                                                16
                                            ).toLocaleString()}
                                        </td>
                                    </tr>
                                    <tr class="odd:bg-white even:bg-gray-50 border-b">
                                        <td class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                            Base Fee Per Gas
                                        </td>
                                        <td class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                            {parseInt(
                                                block?.baseFeePerGas._hex,
                                                16
                                            )}{" "}
                                            Gwei
                                        </td>
                                    </tr>
                                    <tr class="odd:bg-white even:bg-gray-50 border-b">
                                        <td class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                            Burnt Fees
                                        </td>
                                        <td class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                            {(parseInt(
                                                block.gasUsed?._hex,
                                                16
                                            ) *
                                                parseInt(
                                                    block.baseFeePerGas._hex,
                                                    16
                                                )) /
                                                1e9}{" "}
                                            ETH
                                        </td>
                                    </tr>
                                    <tr class="odd:bg-white even:bg-gray-50 border-b">
                                        <td class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                            Extra Data
                                        </td>
                                        <td class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                            {block?.extraData}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default Block;
